// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"310caeeb","87":"5463b945","100":"601cfcbd","213":"20618c14","221":"1130ed35","239":"1339089d","453":"d10b6017","667":"d3380f10","739":"30ab839a"}[chunkId] + ".chunk.js";
};